import React from "react"

const CrossIcon = ({ color = "#2A272B" }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9631 4.03687L3.99999 16" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.03687 4L16 15.9631" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default CrossIcon